import React from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  Link,
  Divider,
} from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        backgroundColor: '#470271', 
        color: 'white', 
        py: 6,
        mt: 8
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Insurance Products
            </Typography>
            <Box>
              <Link href="/auto-insurance" color="inherit" underline="hover">
                Auto Insurance
              </Link>
            </Box>
            <Box>
              <Link href="/home-insurance" color="inherit" underline="hover">
                Home Insurance
              </Link>
            </Box>
            <Box>
              <Link href="/business-insurance" color="inherit" underline="hover">
                Business Insurance
              </Link>
            </Box>
            <Box>
              <Link href="/life-insurance" color="inherit" underline="hover">
                Life Insurance
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Customer Service
            </Typography>
            <Box>
              <Link href="/claims" color="inherit" underline="hover">
                File a Claim
              </Link>
            </Box>
            <Box>
              <Link href="/customer-portal" color="inherit" underline="hover">
                Customer Portal
              </Link>
            </Box>
            <Box>
              <Link href="/contact" color="inherit" underline="hover">
                Contact Us
              </Link>
            </Box>
            <Box>
              <Link href="/faq" color="inherit" underline="hover">
                FAQ
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Company
            </Typography>
            <Box>
              <Link href="/about" color="inherit" underline="hover">
                About Us
              </Link>
            </Box>
            <Box>
              <Link href="/careers" color="inherit" underline="hover">
                Careers
              </Link>
            </Box>
            <Box>
              <Link href="/digital-transformation" color="inherit" underline="hover">
                Digital Solutions
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contact Info
            </Typography>
            <Typography variant="body2" gutterBottom>
              Parsippany, New Jersey
            </Typography>
            <Typography variant="body2" gutterBottom>
              1-800-MOSTLY-SAFE
            </Typography>
            <Typography variant="body2" gutterBottom>
              info@mostlysafe.com
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
            © 2024 Mostly Safe Insurance. All rights reserved. | 36+ years of mostly reliable service.
          </Typography>
          
          <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
            Powered by{' '}
            <Link href="https://microstrat.com" color="#1A92C0" underline="hover">
              Micro Strategies
            </Link>
          </Typography>
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="rgba(255, 255, 255, 0.5)">
            Intelligent Content Management powered by Box.com | Modern content services for the insurance industry
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;